
import { Vue, Component, Prop } from "vue-property-decorator";
import { SchoolIdentityUserDto, OrderRecordDto } from "@/api/service-proxies";

@Component({})
export default class PaidParent extends Vue {
  @Prop() lastPaidUser!: SchoolIdentityUserDto;
  @Prop() lastOrderRecord!: OrderRecordDto;

  created() {}
}
